export default {
    roleList: [
        {
            label: "普通用户",
            value: 1,
        },
        {
            label: "超级管理员",
            value: 2,
        },
    ],
    userType: {
        1: "业主",
        2: "洗手",
        3: "车主",
    },
    orderStatus: {
        0: "待支付",
        1: "已支付",
        2: "待评价",
        3: "已完成",
        4: "待退款",
        5: "已取消",
        6: "已退款",
        7: "洗手已退回",
    },
};
